import { defaultClient } from '@api/client';

export const deleteUser = ({ id }) => {
  return defaultClient.delete(`/admin/users/${id}`);
};
